import React from 'react';
import { Link, NavLink, Outlet, Navigate, useNavigate } from 'react-router-dom';
import { LayoutDashboard, ShoppingBag, Settings, LogOut, Package, Star } from 'lucide-react';
import useSWR from 'swr';
import { adminGetSettings } from '../../lib/api';

const AdminLayout = () => {
  const token = localStorage.getItem('ws_admin_token');
  const navigate = useNavigate();
  const { data: settings } = useSWR(token ? 'adminSettings' : null, adminGetSettings);

  if (!token) return <Navigate to="/admin/login" replace/>;

  const logout = () => {
    localStorage.removeItem('ws_admin_token');
    navigate('/admin/login');
  };

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 text-sm rounded transition-colors ${
      isActive ? 'bg-[#b8892d] text-white' : 'text-neutral-700 hover:bg-neutral-100'
    }`;

  return (
    <div className="min-h-screen bg-neutral-100 flex">
      <aside className="w-64 bg-white border-r border-neutral-200 flex flex-col">
        <div className="p-5 border-b border-neutral-200">
          <Link to="/" className="flex items-center gap-2">
            {settings?.logo_image ? (
              <img 
                src={settings.logo_image} 
                alt={settings.siteName || "Watch Trader"} 
                style={{ maxWidth: settings.logo_width ? `${settings.logo_width}px` : '120px' }} 
                className="object-contain max-h-12" 
              />
            ) : (
              <>
                <div className="w-9 h-9 rounded-full bg-[#b8892d] flex items-center justify-center text-white font-serif">W</div>
                <div>
                  <div className="font-serif text-lg leading-none">Watch Trader</div>
                  <div className="text-[10px] tracking-widest uppercase text-neutral-500 mt-1">Admin</div>
                </div>
              </>
            )}
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          <NavLink to="/admin/orders" className={linkCls}><ShoppingBag size={16}/> Orders</NavLink>
          <NavLink to="/admin/products" className={linkCls}><Package size={16}/> Products</NavLink>
          <NavLink to="/admin/reviews" className={linkCls}><Star size={16}/> Reviews</NavLink>
          <NavLink to="/admin/settings" className={linkCls}><Settings size={16}/> Settings</NavLink>
        </nav>
        <div className="p-3 border-t border-neutral-200">
          <button onClick={logout} className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-neutral-700 hover:bg-neutral-100 rounded">
            <LogOut size={16}/> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <Outlet/>
      </main>
    </div>
  );
};

export default AdminLayout;
